// extracted by mini-css-extract-plugin
export default {"slideshowContainer":"Slideshow_slideshowContainer__eJ861"};